import { Component, Input, inject } from '@angular/core';

import { HideSplash } from 'src/app/@shared/hide-splash.decorator';
import { SetStatusBar } from 'src/app/@shared/status-bar.decorator';
import { ToastService } from 'src/app/@core/toast.service';

import { BaseDetailPage } from 'src/app/@shared/base-detail-page';
import { DatasetFormCompleteStatus, DatasetFormStatus } from 'src/app/@shared/form/base-form.component';
import { OrganizationModel } from 'src/app/organization/@shared/organization.model';
import { OrganizationSubType } from '@api/organization/@shared/organization.entity';

@HideSplash()
@SetStatusBar()
@Component({
  selector: 'page-organization-edit',
  standalone: false,
  styleUrls: ['./organization-edit.page.scss'],
  templateUrl: './organization-edit.page.html',
})
export class OrganizationEditPage extends BaseDetailPage<OrganizationModel> {
  @Input() public item: OrganizationModel;

  public readonly pageTrackName = 'OrganizationEditPage';

  // isEditMode = false -> create new entry, isEditMode = true -> update existing entry
  public isEditMode: boolean;
  public status: DatasetFormStatus;

  protected isStaticPage: boolean = true;

  private lastKnownSubType: OrganizationSubType;

  private toastService = inject(ToastService);

  public onProcessCompleted(formCompleteType: DatasetFormCompleteStatus): void {
    switch (formCompleteType) {
      case 'submitted':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_SUCCESS.MESSAGE')).catch();

        if (this.lastKnownSubType && this.lastKnownSubType !== this.item.subType) {
          this.navController.navigateRoot(`/main/organizations/selfHelpAddress/${this.item.subType}/${this.item.id}`).catch();
        } else {
          this.back().catch();
        }
        break;

      case 'denied':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_SUCCESS.MESSAGE'), {
          color: 'warning',
        }).catch();

        this.back().catch();

        break;

      case 'error':
        this.toastService.show(this.translate.instant('VIEW.COMMON.TOAST.SAVE_ERROR.MESSAGE'), {
          color: 'danger',
        }).catch();
        break;

      default:
        this.back().catch();
        break;
    }
  }

  public async back(): Promise<void> {
    await this.modalController.dismiss();

    return Promise.resolve();
  }

  protected protoOnInit(): void {
    this.isEditMode = !!this.item?.id;

    if (this.isEditMode) {
      this.status = 'edit';
      this.lastKnownSubType = this.item.subType;
    } else {
      this.status = 'new';
    }
  }
}
